import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
  const { userProfile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="spinner"></div>
        <p>Verifying Credentials...</p>
      </div>
    );
  }

  // Check if user is logged in
  if (!userProfile) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if account is active/approved (for security)
  if (userProfile.status === 'suspended') {
    return <Navigate to="/suspended" replace />;
  }

  if (userProfile.status === 'pending' || !userProfile.role) {
    return (
      <div style={{
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh', 
        textAlign: 'center',
        background: 'var(--bg-dark)',
        color: '#fff',
        padding: '20px'
      }}>
        <i className="fa-solid fa-user-lock" style={{fontSize: '4rem', color: '#ff375f', marginBottom: '20px'}}></i>
        <h1>Access Restricted</h1>
        <p style={{color: 'var(--text-secondary)', maxWidth: '500px'}}>
          Your account is currently pending administrative approval. 
          Please contact the system owner if you believe this is an error.
        </p>
        <button className="auth-btn" onClick={() => window.location.href = '/dashboard'} style={{marginTop: '20px', width: 'auto', padding: '10px 30px'}}>
          Return to Dashboard
        </button>
      </div>
    );
  }

  return children;
};

export default AdminRoute;
